import { CONSUMER_ENVIRONMENT_LABELS, TICKET_CHANNEL_LABELS, type TicketDetail } from '@easyhelp/shared';
import { DetailSection, FactList } from './DetailSection';

/**
 * Provenienza: consumer, canale e ambiente vengono dal token del consumer (DEC-006), mai dal
 * payload. Il prodotto non compare: si legge nel prefisso del codice (DEC-003).
 */
export function TicketProvenanceSection({ ticket }: { ticket: TicketDetail }) {
  return (
    <DetailSection title="Provenienza">
      <FactList
        facts={[
          { label: 'Committente', value: ticket.committente, missing: 'Non identificato (pre-accesso)' },
          { label: 'Consumer', value: ticket.consumer.name },
          { label: 'Canale', value: TICKET_CHANNEL_LABELS[ticket.channel] },
          { label: 'Ambiente', value: CONSUMER_ENVIRONMENT_LABELS[ticket.environment] },
          { label: 'Categoria dichiarata', value: ticket.category },
        ]}
      />
    </DetailSection>
  );
}
